import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../ErrorPage";

const TechnicalError = () => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  return (
    <ErrorPage
      title={t("technicalError.title")}
      subtitle={t("technicalError.subtitle") as string}
      icon={{
        Component: ReportGmailerrorredIcon,
        styles: {
          color: theme.tokens.FuelColorAlertErrorIcon,
          height: theme.tokens.FuelFontSize5xl,
          width: theme.tokens.FuelFontSize5xl,
        },
      }}
      returnHomeButtonText={t("technicalError.returnHome.button") as string}
    />
  );
};

export default TechnicalError;
